import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useDeviceStates } from '@/constants/DeviceStates.jsx';
import DeviceCodeErrorTooltip from '@/components/device/DeviceCodeErrorTooltip.jsx';

export const DeviceStateField = ({ record, className }) => {
    const deviceStates = useDeviceStates();
    if (!record?.state) return null;
    const state = deviceStates.find(s => s.id === record.state);

    if (!state) return <Typography>Unknown</Typography>;

    const content = (
        <Box className={className} sx={{ display: 'flex', alignItems: 'center' }}>
            {state.icon && <Box sx={{ marginRight: '8px', height: '20px' }}>{state.icon}</Box>}
            <Typography className='device-state-field-name' component='span' sx={{ whiteSpace: 'nowrap' }}>
                {state.name}
            </Typography>
        </Box>
    );

    if (!state.tooltip) {
        return content;
    }

    return <DeviceCodeErrorTooltip currentErrorCodes={record.currentErrorCodes}>{content}</DeviceCodeErrorTooltip>;
};

DeviceStateField.propTypes = {
    record: PropTypes.shape({
        state: PropTypes.string,
        currentErrorCodes: PropTypes.array,
    }),
    className: PropTypes.string,
};
